module.exports = __webpack_public_path__ + "static/media/arro-l-png.655af27e.png";